import React from 'react';
import GenericModulePage from '../../components/generic/GenericModulePage';
import { initializeModule } from '../../utils/configInit';
import { changeRequestConfig } from './changeRequestConfig';
import { createChangeRequestValidationSchema } from './changeRequestValidation';

const { config: initializedConfig } = initializeModule(
  changeRequestConfig,
  createChangeRequestValidationSchema,
);

const ChangeRequestPage = () => {
  return <GenericModulePage config={initializedConfig} />;
};

export default ChangeRequestPage;
